import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function ThankYou() {
  return (
    <>
      <Helmet>
        <title>Order Confirmed | Clinic</title>
      </Helmet>
      <div className="page-title">

      </div>

      <div className="bg-success text-white text-center py-5">
        <div className="container">
          <i
            className="bi bi-check-circle-fill"
            style={{ fontSize: "80px" }}
          ></i>

          <h2 className="fw-bold mt-3">
            Order Placed Successfully
          </h2>

          <p className="mb-0">
            Thank you for shopping with us!
          </p>
        </div>
      </div>

      <section className="container my-5">
        <div className="card shadow-sm border-0">
          <div className="card-body text-center py-5">

            <h5 className="fw-semibold mb-3">
              Your order has been confirmed
            </h5>

            <p className="text-muted mb-4">
              We have received your order and it will be processed shortly.
              You can track your order status in your account.
            </p>

            <div className="d-flex justify-content-center gap-3">

              <NavLink to="/order" className="btn btn-success px-4">
                View Orders
              </NavLink>

              <NavLink to="/medicine" className="btn btn-outline-secondary px-4">
                Continue Shopping
              </NavLink>

            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default ThankYou;
